import React from "react";
import { FaFaucet, FaToilet, FaSink, FaShower, FaTint, FaFire } from "react-icons/fa";
import { ServiceCardGrid } from "./ElectricianServices";
import { HANDYMAN_PRICE_PAGE, jobPagePath } from "data/handyman-job-pages";

// Plumber-specific service cards for /sg/plumber-singapore-services. They
// replace the generic HandymanServices cards, which put painting, furniture
// and electrical copy on a page that should rank for "plumber singapore".
// Prices are looked up from the live price list by exact itemName.
const plumberServicesData = [
  {
    title: "Faucet, Sink & Pipe Leaks",
    desc: [
      "Dripping faucets, leaks under the sink or basin, loose flexible hoses and leaking exposed pipes",
      "We trace the leak to its source first, so only the faulty part is repaired or replaced",
    ],
    prices: [["Fix water leak from faucet, sink or pipes", "Leak repair"]],
    href: jobPagePath("leaking-faucet-sink-pipe-repair"),
    icon: FaTint,
  },
  {
    title: "Clogged Toilet Bowl",
    desc: [
      "Clearing choked toilet bowls caused by paper build-up, wet wipes or dropped objects",
      "Weak flushes that cause repeat chokes are fixed at the flush system or siphon",
    ],
    prices: [["Clear clogged toilet bowl", "Toilet choke"]],
    href: jobPagePath("clogged-toilet-bowl"),
    icon: FaToilet,
  },
  {
    title: "Clogged Kitchen Sink",
    desc: [
      "Unclogging kitchen sinks and pipes blocked by grease, food scraps and coffee grounds",
      "Cracked or leaking bottle traps replaced under the sink",
    ],
    prices: [["Clear clogged kitchen sink or pipe", "Sink unclogging"]],
    href: jobPagePath("clogged-kitchen-sink"),
    icon: FaSink,
  },
  {
    title: "Clogged Bathroom Drain",
    desc: [
      "Clearing floor traps and bathroom drainage pipes blocked by hair, soap scum or renovation debris",
      "For showers that pool water or floor traps that drain slowly",
    ],
    prices: [["Clear clogged drainage pipe", "Drain clearing"]],
    href: jobPagePath("clogged-bathroom-drain"),
    icon: FaShower,
  },
  {
    title: "Toilet, Tap & Shower Replacement",
    desc: [
      "Replacing toilet flush systems, toilet bowl sets, kitchen faucets, shower sets and wash basins",
      "Suitable for HDB flats, BTO units and condominiums across Singapore",
    ],
    prices: [["Replace toilet flush system", "Flush system"], ["Replace kitchen faucet", "Faucet"]],
    href: HANDYMAN_PRICE_PAGE + "#prices-plumbing",
    linkLabel: "See bathroom and kitchen prices",
    icon: FaFaucet,
  },
  {
    title: "Water Heater Replacement",
    desc: [
      "Replacing instant and storage water heaters, and fixing heaters that leak or give no hot water",
      "The electrical supply point can be added in the same visit",
    ],
    prices: [["Replace instant water heater", "Instant heater"], ["Replace storage water heater", "Storage heater"]],
    href: jobPagePath("water-heater-installation"),
    icon: FaFire,
  },
];

export const PlumberServices = ({ handymanPriceList = [] }) => (
  <ServiceCardGrid
    cards={plumberServicesData}
    handymanPriceList={handymanPriceList}
    image="handyman/handyman-plumber-fixing-kitchen-pipes.jpg"
    imageAlt="Plumber fixing kitchen pipes in a Singapore home - StringsSG"
  />
);
